<!-- Header component for Time and Expense -->
<div
  [ngClass]="{
    'entry-header-small-screen': isSmallScreen(),
    'entry-header-large-screen': isLargeScreen()
  }"
>
  <div class="flex flex-wrap flex-col tb:flex-row justify-start" [appDynamicStyles]="{ 'column-gap': { zoomout: '28px', zoomin: '14px' },  'row-gap': { zoomout: '12px', zoomin: '6px' }}">
    <!-- New Entry Button -->
    <div>
      <button
        mat-raised-button
        matTooltip="Add new time entry"
        matTooltipClass="sidenavTooltip"
        class="flex items-center entry-page-button disabled:opacity-50 cursor-not-allowed enabled:cursor-pointer"
        (click)="openSustainabilityDialog()"

        [appDynamicStyles]="{ 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px 12px 8px 8px' , zoomin: '4px 8px 4px 4px'}}"
      >
        <div class="flex flex-row gap-1">
          <div class="flex items-center" [appDynamicStyles]="{ 'height': { zoomout: '28px', zoomin: '14.5px' }}">
            <mat-icon>add</mat-icon>
          </div>
          <div class="flex items-center font-sans" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '28px', zoomin: '14.5px' } }">New</div>
        </div>
      </button>
    </div>
    <!-- Copy Previous Month Button -->
    <div *ngIf="entryPageType === 'Sustainability'">
      <button
        mat-raised-button
        matTooltip="Copy entries from the previous month"
        matTooltipClass="sidenavTooltip"
        class="flex items-center entry-page-button disabled:opacity-50 cursor-not-allowed enabled:cursor-pointer"
        (click)="copyPreviousMonth()"
        [disabled]="isSaving"
        [appDynamicStyles]="{ 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px 12px 8px 8px' , zoomin: '4px 8px 4px 4px'}}"
      >
        <div class="flex flex-row gap-1">
          <div class="flex items-center" [appDynamicStyles]="{ 'height': { zoomout: '28px', zoomin: '14.5px' }}">
            <mat-icon>content_copy</mat-icon>
          </div>
          <div class="flex items-center font-sans" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '28px', zoomin: '14.5px' } }">Copy Previous Month</div>
        </div>
      </button>
    </div>
    <!-- Dashboard -->
    <div *ngIf="entryPageType != 'Expense'">
      <button
        mat-raised-button
        class="flex items-center entry-page-button disabled:opacity-50"
        (click)="openChartDashboard()"
        [disabled]="false"
        
        [appDynamicStyles]="{ 'height': { zoomout: '40pxsa', zoomin: '30px' }, 'padding': {zoomout: '8px 12px 8px 8px' , zoomin: '4px 8px 4px 4px'}}"
        
      >
        <div class="flex flex-row gap-1">
          <div class="flex items-center" [appDynamicStyles]="{ 'height': { zoomout: '28px', zoomin: '14.5px' }}">
            <mat-icon>bar_chart</mat-icon>
          </div>
          <div class="flex items-center font-sans" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '28px', zoomin: '14.5px' } }">Dashboard</div>
        </div>
      </button>
    </div>
    <!-- Save Entries Button -->
    <div>
      <button
        mat-raised-button
        class="flex items-center entry-page-button disabled:opacity-50 cursor-not-allowed enabled:cursor-pointer"
        (click)="onSave()"
        [appDynamicStyles]="{ 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px 12px 8px 8px' , zoomin: '4px 8px 4px 4px'}}"
        [disabled]="isWriteSilence || !isUnsavedChangesPresent || !isSaveEnabled || isSaving"
      >
        <div class="flex flex-row gap-1">
          <div class="flex items-center" [appDynamicStyles]="{ 'height': { zoomout: '28px', zoomin: '14.5px' }}">
            <mat-icon>save</mat-icon>
          </div>
          <div class="flex items-center font-sans" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '28px', zoomin: '14.5px' } }">Save</div>
        </div>
      </button>
    </div>
    <!-- Delete Entries Button -->
    <div>
  <button
    mat-raised-button
    class="flex items-center entry-page-button disabled:opacity-50 cursor-not-allowed enabled:cursor-pointer"
    (click)="deleteButtonClicked()"
    [appDynamicStyles]="{ 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px 12px 8px 8px' , zoomin: '4px 8px 4px 4px'}}"
    [disabled]="!isSelectedforDeletion"
  >
    <div class="flex flex-row gap-1">
      <div class="flex items-center" [appDynamicStyles]="{ 'height': { zoomout: '28px', zoomin: '14.5px' }}">
        <mat-icon>delete_outline</mat-icon>
      </div>
      <div class="flex items-center font-sans" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '28px', zoomin: '14.5px' } }">Delete</div>
    </div>
  </button>
</div>
    <!-- Reset Button -->
    <div>
      <button
        [matMenuTriggerFor]="resetMenu"
        mat-raised-button
        [appDynamicStyles]="{ 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px 12px 8px 8px' , zoomin: '4px 8px 4px 4px'}}"
        class="flex items-center entry-page-button"
        
      >
        <div class="flex flex-row gap-1">
          <div class="flex items-center" [appDynamicStyles]="{ 'height': { zoomout: '28px', zoomin: '14.5px' }}">
            <mat-icon>restore</mat-icon>
          </div>
          <div class="flex items-center font-sans" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '28px', zoomin: '14.5px' } }">Reset</div>
        </div>
      </button>
      <mat-menu
        #resetMenu="matMenu"
        [overlapTrigger]="false"
        class="bg-white shadow-2xl rounded"
        [xPosition]="'after'"
      >
        <!-- Reset Rows Data -->
        <button
          [disabled]="isWriteSilence || !isUnsavedChangesPresent"
          matTooltip="Reset time entry changes"
          class="enabled:cursor-pointer disabled:opacity-50 cursor-not-allowed mat_option--Itemstyle"
          mat-menu-item
          (click)="onResetClicked()"
          [disabled]="!isResetEnabled"

          [appDynamicStyles]="{ 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px' , zoomin: '4px'}}"
        >
          <mat-icon class="h-4 w-4 min-h-4 min-w-4">bar_chart</mat-icon>
          <span>Reset Data</span>
        </button>
        <!-- <button mat-menu-item class="mat_option--Itemstyle" (click)="resetColumnsButtonClicked()">
                    <mat-icon>undo</mat-icon>
                    <span>Reset Columns</span>
                </button> -->
      </mat-menu>
    </div>
    
    <!-- Year & Quarter Filters -->
    <mat-form-field appearance="fill" class="year-month-dropdown">
  <mat-select
    placeholder="Select Year and Month"
    multiple
    [value]="selectedYearMonthPairs"
    (selectionChange)="onYearMonthChange($event.value)">
    
    <mat-optgroup *ngFor="let yr of years" [label]="yr">
      <mat-option
        *ngFor="let month of getMonthsForYear(yr)"
        [value]="getYearMonthValue(yr, month.label)"
        [disabled]="isFutureTimePeriod(yr, month.value)"
        (click)="onMonthOptionClicked(yr, month.label)">
        {{ month.label }}
      </mat-option>
    </mat-optgroup>
  </mat-select>
</mat-form-field>

    
    
    
    
    
  <!-- <div class="drag-mode flex font-sans justify-center gap-1" [appDynamicStyles]="{ 'font-size': {zoomout: '16px', zoomin: '14.5px'}, 'height': { zoomout: '40px', zoomin: '30px' }, 'padding': {zoomout: '8px' , zoomin: '4px'} }">
  <mat-label>Drag Mode : Move </mat-label>
  <mat-slide-toggle [checked]="rowDragMode" (change)="toggleValueChanged()">
  </mat-slide-toggle>
  <mat-label>Copy</mat-label>
  </div> -->
</div>
</div>
